import axios from "axios";

import {
  GET_ComCh,
  RESET_ComCh,
  LOADING
} from "../actionTypes";
import { DEV_APIS_URL } from "configurations";
import { adminTokenDev } from "../../helper";

const { SET_TRUE, SET_FALSE } = LOADING;

export const get = () => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.get(
          `${DEV_APIS_URL}/communication-channels`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch({ type: GET_ComCh, payload: res.data });
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const add = ({ name = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.post(
          `${DEV_APIS_URL}/communication-channels`,
          {
            "channel_name": `${name}`
          },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const update = ({ id = "", name = "" }) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.put(
          `${DEV_APIS_URL}/communication-channels`,
          {
            "id":id,
            "channel_name": `${name}`
        },
          
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const deletedata = ({ id = ""}) => {
  return dispatch => {
    dispatch({ type: SET_TRUE });

    adminTokenDev()
      .then(token =>
        axios.delete(
        `${DEV_APIS_URL}/communication-channels/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
      )
      .then(res => {
        dispatch(get());
      })
      .catch(err => console.log(err))
      .finally(_ => dispatch({ type: SET_FALSE }));
  };
};

export const reset = () => dispatch => dispatch({ type: RESET_ComCh });
